import { deleteRest, get, post, put } from 'utils/rxfetch'

// Custom ATO escalation (correlation) rules. Backend contract is camelCase JSON
// (CamelCaseJSONRenderer/Parser), so send and read camelCase keys directly — no
// snake_case transform. See webapp/rest/ato_correlation_rules_rest.py.
const BASE = '/members-api/ato-correlation-rules'

// MSP partner scoping: mirror the other settings endpoints and pass the selected
// child company id through the companyFilter query param.
const withCompany = (path, companyId = '') =>
  companyId ? `${path}?companyFilter=${companyId}` : path

export default () => ({
  getAllowedTitles(companyId = '') {
    return get(withCompany(`${BASE}/allowed-titles/`, companyId))
  },
  listRules(companyId = '') {
    return get(withCompany(`${BASE}/`, companyId))
  },
  createRule(body, companyId = '') {
    return post(withCompany(`${BASE}/`, companyId), body)
  },
  updateRule(id, body, companyId = '') {
    return put(withCompany(`${BASE}/${id}/`, companyId), body)
  },
  deleteRule(id, companyId = '') {
    return deleteRest(withCompany(`${BASE}/${id}/`, companyId))
  },
  previewRule(body, companyId = '') {
    return post(withCompany(`${BASE}/preview/`, companyId), body)
  },
})
